import { gql } from '@apollo/client';

export const UPDATE_VIBRATION_MONITOR = gql`
    mutation UpdateVibrationMonitor($id: Guid!, $input: UpdateVibrationMonitor!) {
        facility {
            process {
                updateVibrationMonitor(id: $id, input: $input) {
                    id
                }
            }
        }
    }
`;
